import * as Types from '../../../__generated__/api/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CustomerTypeQueryVariables = Types.Exact<{ [key: string]: never }>;

export type CustomerTypeQuery = {
  customerType: {
    __typename: 'CustomerType';
    id: string;
    subscriptionTracking: Types.Scalars['JSON']['output'] | null;
    products: Array<{
      __typename: 'CustomerProduct';
      id: string;
      providerId: string;
      providerType: Types.ProviderType;
    }>;
  } | null;
};

export const CustomerTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CustomerType' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerType' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'products' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'providerType' } },
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subscriptionTracking' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CustomerTypeQuery, CustomerTypeQueryVariables>;
